import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';

const enum FilePickerErrorMessageType {
    Generic,
    NotFound,
    AccessDenied,
    NoItems,
    NoItemsSearch,
    Searching,
    NoProviders,
}

export default FilePickerErrorMessageType;

export interface FilePickerErrorMessage {
    message: string;
    icon: string;
    messageSubtext?: string;
}

export const errorMessageMap: {
    [filePickerErrorMessageType: number]: () => FilePickerErrorMessage;
} = {
    [FilePickerErrorMessageType.Generic]: () =>
        <FilePickerErrorMessage>{
            message: strings.GenericErrorText,
            icon: 'o365-Icon--emptyError',
        },
    [FilePickerErrorMessageType.NotFound]: () =>
        <FilePickerErrorMessage>{
            message: strings.NotFoundErrorText,
            icon: 'o365-Icon--folderClosed',
        },
    [FilePickerErrorMessageType.AccessDenied]: () =>
        <FilePickerErrorMessage>{
            message: strings.AccessDeniedErrorText,
            icon: 'o365-Icon--lock3',
        },
    [FilePickerErrorMessageType.NoItems]: () =>
        <FilePickerErrorMessage>{ message: strings.NoItemsText, icon: 'o365-Icon--emptyFolder' },
    [FilePickerErrorMessageType.NoItemsSearch]: () =>
        <FilePickerErrorMessage>{
            message: strings.EmptySearchResultTitleText,
            icon: 'o365-Icon--emptyDocumentSearch',
            messageSubtext: strings.EmptySearchResultDescriptionText,
        },
    [FilePickerErrorMessageType.Searching]: () =>
        <FilePickerErrorMessage>{
            message: strings.SearchingText,
            icon: 'o365-Icon--magnifyingGlass',
        },

    // TODO: bug 14882, this string is specific to OneDrive, we should modify it to also work with cloud cache.
    [FilePickerErrorMessageType.NoProviders]: () =>
        <FilePickerErrorMessage>{
            message: format(strings.NoProviderErrorText, strings.OneDriveFileProviderDisplayName),
            icon: 'o365-Icon--folderClosed',
        },
};
